'use client';
import { ToggleButtonStyled } from './toggle-button.styles';

const ToggleButton = ToggleButtonStyled;

export default ToggleButton;
